import { jsx as o } from "react/jsx-runtime";
import s from "clsx";
import r from "./MenuDrawer.module.css.js";
const t = ({ fullWidth: e = !1, className: m, ...a }) => /* @__PURE__ */ o(
  "div",
  {
    className: s(r.menuDrawer, m, {
      [r.fullWidth]: e
    }),
    ...a
  }
);
t.displayName = "MenuDrawer";
export {
  t as MenuDrawer
};
//# sourceMappingURL=MenuDrawer.js.map
